var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconoNominaHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4247",
    "data-name": "Rect\\xE1ngulo 4247",
    width: 60.128,
    height: 57.261,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_22221",
    "data-name": "Grupo 22221",
    transform: "translate(-452 -564)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_22176",
    "data-name": "Grupo 22176",
    transform: "translate(0 23)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1569",
    "data-name": "Elipse 1569",
    cx: 50,
    cy: 50,
    r: 50,
    transform: "translate(452 541)",
    fill: "#00a29a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_22220",
    "data-name": "Grupo 22220",
    transform: "translate(474.936 584.37)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_22159",
    "data-name": "Grupo 22159",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24590",
    "data-name": "Trazado 24590",
    d: "M60.128,15.13c-.172.818-.3,1.65-.522,2.453a13.847,13.847,0,0,1-13.429,10.11h-.626v.686q0,10.539,0,21.077A7.6,7.6,0,0,1,39.307,57.1a13.067,13.067,0,0,1-2.452.151q-14.5.014-29,0A7.693,7.693,0,0,1,0,49.425q0-1.937,0-3.875c0-.876.316-1.195,1.207-1.2,1.977-.007,3.953,0,5.93,0H7.85c.014-.233.035-.438.036-.642q.115-16.5.227-32.994C8.122,9.4,8.379,9.15,9.705,9.15q11.478,0,22.956.01a.761.761,0,0,0,.848-.563A13.817,13.817,0,0,1,60.02,12.162a2.442,2.442,0,0,0,.109.384ZM10.064,11.14c-.074,11.073-.149,22.114-.223,33.21H23.42q3.786,0,7.572,0c.863,0,1.156.3,1.165,1.169.005.47,0,.939,0,1.409a26.827,26.827,0,0,0,.083,3.516,5.7,5.7,0,0,0,11.337-.9c.019-7.2,0-14.4.017-21.6,0-.424-.142-.545-.537-.645a13.5,13.5,0,0,1-8.035-5.516.952.952,0,0,0-.909-.454c-3.072.015-6.144.009-9.216.007a3.47,3.47,0,0,1-.585-.024.971.971,0,0,1,.038-1.927,3.725,3.725,0,0,1,.528-.015h8.756a14.183,14.183,0,0,1-.92-8.232Zm48.107,2.752A11.878,11.878,0,1,0,46.277,25.737,11.871,11.871,0,0,0,58.171,13.893M1.957,46.315c0,1.028-.005,2.021,0,3.014A5.708,5.708,0,0,0,7.942,55.3q12.061,0,24.122,0h.563l.127-.184a1.588,1.588,0,0,1-.4-.226,7.136,7.136,0,0,1-2.064-4.306c-.1-1.067-.072-2.147-.1-3.222-.008-.344,0-.688,0-1.044Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24591",
    "data-name": "Trazado 24591",
    d: "M199.072,297.184q3.023,0,6.047,0a3,3,0,0,1,.641.042.9.9,0,0,1,.76.913.929.929,0,0,1-.775.968,2.1,2.1,0,0,1-.525.027q-6.164,0-12.328,0a2.152,2.152,0,0,1-.468-.019.921.921,0,0,1-.81-.934.9.9,0,0,1,.77-.961,2.634,2.634,0,0,1,.583-.037q3.053,0,6.105,0",
    transform: "translate(-168.128 -260.759)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24592",
    "data-name": "Trazado 24592",
    d: "M199.027,227.757q3.14,0,6.281,0c.763,0,1.2.371,1.19.981-.013.588-.435.945-1.173.946q-6.281.008-12.561,0c-.778,0-1.195-.366-1.182-.989s.426-.939,1.224-.94q3.111,0,6.222,0",
    transform: "translate(-168.099 -199.84)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24593",
    "data-name": "Trazado 24593",
    d: "M345.914,60.67c-.022-.92.309-1.342.9-1.375s.971.342,1.042,1.031a1.945,1.945,0,0,0,3.889-.08,1.957,1.957,0,0,0-1.973-1.945,3.9,3.9,0,0,1-1.318-7.553.817.817,0,0,0,.393-.459.952.952,0,0,1,.954-.751.964.964,0,0,1,.949.759.887.887,0,0,0,.452.47,3.951,3.951,0,0,1,2.488,3.522.959.959,0,0,1-1.049,1.066c-.537-.039-.828-.381-.9-1.055a1.948,1.948,0,1,0-3.878.358,1.988,1.988,0,0,0,1.809,1.695,6.849,6.849,0,0,1,1.29.19,3.87,3.87,0,0,1,.354,7.266,1.007,1.007,0,0,0-.656.671,1.269,1.269,0,0,1-.847.615.762.762,0,0,1-.905-.61c-.082-.405-.312-.535-.642-.68a3.743,3.743,0,0,1-2.35-3.135",
    transform: "translate(-303.496 -43.466)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24594",
    "data-name": "Trazado 24594",
    d: "M126.037,141.154a3.114,3.114,0,1,0,3.114,3.114,3.115,3.115,0,0,0-3.114-3.114m1.163,3.3a1.178,1.178,0,1,1-.974-1.353,1.178,1.178,0,0,1,.974,1.353",
    transform: "translate(-107.857 -123.853)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24595",
    "data-name": "Trazado 24595",
    d: "M126.037,210.238a3.114,3.114,0,1,0,3.114,3.114,3.115,3.115,0,0,0-3.114-3.114m1.163,3.3a1.178,1.178,0,1,1-.974-1.353,1.178,1.178,0,0,1,.974,1.353",
    transform: "translate(-107.857 -184.47)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24596",
    "data-name": "Trazado 24596",
    d: "M126.037,279.322a3.114,3.114,0,1,0,3.114,3.114,3.115,3.115,0,0,0-3.114-3.114m1.163,3.3a1.178,1.178,0,1,1-.974-1.353,1.178,1.178,0,0,1,.974,1.353",
    transform: "translate(-107.857 -245.086)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoNominaHome);
export default __webpack_public_path__ + "static/media/Icono_Nomina_Home.20916747a0615a3a3c180dbcf0834589.svg";
export { ForwardRef as ReactComponent };